import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Base from '../Base';
import Back from '../../components/common/Back';
import Card from '../../components/elements/Card';
import Loading from '../../components/common/Loading';
import Title from '../../components/common/Title';
import InvoiceCapture from '../../components/sales/InvoiceCapture';
import { apiRequest } from '../../utils';
import '../../pages/sales/Sales.css';

/* The invoices we received — a page of its own, off the road home.

   ★ It used to be a second card ON the internal home, which read well on paper
   and wrong in the hand: a rep opens that screen several times a day to look a
   company up before walking in, and an invoice arrives now and then. Two jobs
   competing for the top of one screen means the frequent one loses. So the road
   home keeps a single focus and carries a discreet button down here.

   Somebody granted ONLY the capture never sees this page: their internal home
   renders the same component inline, because for them it is not a detour — it is
   the whole job. */
const FinanceHome = () => {
  const { t } = useTranslation();
  const [context, setContext] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await apiRequest('GET', '/sales/context');
        // Same fallback as the road home: the server will not pick a unit for
        // somebody granted several, and a null one is a camera wired to nothing.
        if (!data.business_unit_id && data.business_units?.length) {
          data.business_unit_id = data.business_units[0].id;
        }
        setContext(data);
      } catch {
        setContext(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <Base activeNav="home"><Loading /></Base>;

  // `!== false` rather than `=== true`: an older payload carries neither flag,
  // and defaulting to refused would lock somebody out mid-deploy.
  const canCapture = context?.can_capture !== false;
  const canSell = context?.can_sell !== false;

  return (
    <Base activeNav="home">
      {/* Only offered to somebody who has a road home to go back to. */}
      {canSell && <Back to="/sales-home" />}
      <div className="sales-head">
        <Title my="3">{t('financeHome')}</Title>
        {context?.business_units?.length > 1 && (
          <select
            className="sales-input sales-bu"
            value={context.business_unit_id || ''}
            onChange={(e) => setContext({ ...context, business_unit_id: e.target.value })}
          >
            {context.business_units.map((b) => (
              <option key={b.id} value={b.id}>{b.name}</option>
            ))}
          </select>
        )}
      </div>

      {context && canCapture
        ? <InvoiceCapture buId={context.business_unit_id} />
        : <Card><p className="sales-hint">{t('financeNoAccess')}</p></Card>}
    </Base>
  );
};

export default FinanceHome;
